import { createContext, useContext, ReactNode } from 'react';
import { useAiSearchActions } from './hooks/useAiSearchActions';

type AiSearchContextType = ReturnType<typeof useAiSearchActions>;

const AiSearchContext = createContext<AiSearchContextType | undefined>(undefined);

export function AiSearchProvider({ children }: { children: ReactNode }) {
  const value = useAiSearchActions();
  return <AiSearchContext.Provider value={value}>{children}</AiSearchContext.Provider>;
}

export function useAiSearchContext() {
  const context = useContext(AiSearchContext);
  if (!context) {
    throw new Error('useAiSearchContext must be used within AiSearchProvider');
  }
  return context;
}
